import { render } from "./NotificationsMenu.vue?vue&type=template&id=4671a626&scoped=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"

import "./NotificationsMenu.vue?vue&type=style&index=0&id=4671a626&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4671a626"]])

export default __exports__